<template>
    <div class="flex flex-col gap-4 mx-auto w-full mb-8">
        <div class="flex flex-col gap-4">
            <div class="flex flex-wrap justify-center gap-3">
                <reports-tabs
                    :tabs="years"
                    :selected-key="activeYear"
                    @toggle="toggleYear"
                    @on-open-subscribe="handleSubscribeModal"  
                />
            </div>
            <div class="flex flex-wrap flex-row justify-center items-center gap-3">
                <reports-tabs
                    :tabs="type"
                    :selected-key="selectedType"
                    @toggle="toggleType"
                    @on-open-subscribe="handleSubscribeModal"  
                />
            </div>
            <div class="flex gap-4 justify-center w-full mx-auto">
                <base-select
                    v-model="period"
                    class="max-w-xs"
                    :options="periodOptions"
                    @on-select="selectNewPeriod"
                    @on-open-subscribe="handleSubscribeModal"  
                />
                <reports-download 
                    :disabled="!isSubscribe" 
                    :url="files.url" 
                    @on-open-subscribe="handleSubscribeModal"  
                />
            </div>
        </div>
        <iframe
            v-if="files.urlView"
            id="result-iframe"
            name="preview"
            :src="files.urlView"
            width="100%"
            class="relative bg-white block min-h-[725px] -mb-20"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            onload="(function(o){o.style.height=o.contentWindow.document.body.offsetHeight + 168 +'px';}(this));"
        />
    </div>
</template>

<script>
import ReportsTabs from "@/components/Reports2/components/ReportsTabs";
import BaseSelect from "@/UI/BaseSelect";
import ReportsDownload from "@/components/Reports2/components/ReportsDownload";
import store from "@/store";

export default {
    name: "ReportsPreview",
    components: { ReportsDownload, BaseSelect, ReportsTabs },
    props: {
        reports: {
            type: Object,
            required: true
        },
        years: {
            type: Array,
            required: true
        },
        weeks: {
            type: Array,
            default: () => []
        },
        month: {
            type: Array,
            default: () => []
        },
        quarter: {
            type: Array,
            default: () => []
        },
        activeYear: {
            type: String,
            required: true
        }
    },
    emits: [ 'toggle', 'onOpenSubscribe' ],
    setup() {
        const isSubscribe = store.getters["isSubscribe"];
        
        return {
            isSubscribe
        }
    },

    data() {
        return {
            selectedType: '',
            period: null,
            weeksOptions: [],
            monthOptions: [],
            quarterOptions: [],
            currentSlide: 0
        }
    },
    computed: {
        type() {
            const keys = [];

            if (this.weeks.length) {
                this.weeks.forEach(el => this.weeksOptions.push(el.heading));
                const isWeekDisabled = !this.isSubscribe && this.weeksOptions.length <= 1;
                keys.push({ value: 'Неделя', isDisabled: isWeekDisabled });

                if (!isWeekDisabled) {
                    this.selectedType = 'Неделя';
                }
            }

            if (this.month.length) {
                this.month.forEach(el => this.monthOptions.push(el.heading));
                const isMonthDisabled = !this.isSubscribe && this.monthOptions.length <= 1;
                keys.push({ value: 'Месяц', isDisabled: isMonthDisabled });

                if (!isMonthDisabled) {
                    this.selectedType = 'Месяц';
                }
            }

            if (this.quarter.length && this.quarterOptions.length === 0) {
                this.quarter.forEach(el => this.quarterOptions.push(el.heading));
                const isQuarterDisabled = !this.isSubscribe && this.quarterOptions.length <= 1;
                keys.push({ value: 'Квартал', isDisabled: false });

                if (!isQuarterDisabled) {
                    this.selectedType = 'Квартал';
                }
            }

            return keys;
        },

        periodOptions() {
            let period = null
            const isCurrentYearIsActive = Number(this.activeYear) === new Date().getFullYear();

            if (this.selectedType === 'Квартал') {
                period = this.quarterOptions.map(item => ({
                    title: item,
                    value: item,
                    isDisabled: isCurrentYearIsActive && !this.isSubscribe && this.quarterOptions.indexOf(item) === 0
                }));

                if (period.length > 0 && !period[0].isDisabled) {
                    this.period = period[0];
                } else {
                    this.period = null;
                }
            }
            if (this.selectedType === 'Месяц') {
                period = this.monthOptions.map(item => ({
                    title: item,
                    value: item,
                    isDisabled: isCurrentYearIsActive && !this.isSubscribe && this.monthOptions.indexOf(item) === 0
                }))
            }
            if (this.selectedType === 'Неделя') {
                period = this.weeksOptions.map(item => ({
                    title: item,
                    value: item,
                    isDisabled: isCurrentYearIsActive && !this.isSubscribe && this.weeksOptions.indexOf(item) === 0
                }))
            }

            this.period = isCurrentYearIsActive && !this.isSubscribe && period.length > 1 ? period[1] : period[0];

            return period
        },
        files() {
            if (!this.period) {
                return { urlView: null, url: null };
            }

            let find = null;
            if (this.selectedType === 'Квартал') {
                find = this.quarter.filter(i => i.heading === this.period.value)
            }
            if (this.selectedType === 'Месяц') {
                find = this.month.filter(i => i.heading === this.period.value)
            }
            if (this.selectedType === 'Неделя') {
                find = this.weeks.filter(i => i.heading === this.period.value)
            }

            return {
                urlView: find[0].urlView ?? find[0].url,
                url: find[0].url
            }
        }
    },
    methods: {
        toggleYear(value) {
            this.weeksOptions = [];
            this.monthOptions = [];
            this.quarterOptions = [];
            this.$emit('toggle', value)
        },
        toggleType(value) {
            this.selectedType = value;

            if (value === 'Квартал' && this.periodOptions.every(option => option.isDisabled)) {
                this.period = null;
            }
        },
        selectNewPeriod(value) {
            this.period = value
        },
        handleSubscribeModal() {
            this.$emit('onOpenSubscribe');
        },
    }
}
</script>

<style scoped>

</style>